
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage"; // @ is an alias to /src

import { Field } from "vant";
import WxUtil from "@/util/WxUtil";

@Options({
  components: {
    [Field.name]: Field,
  },
})
/**核销搜索 */
export default class SearchPage extends BasePage {
  _title = "核销";
  backcolor = "white";
  orderId = "";

  arr = [
    /**员工*/ { path: "/staff/orderHx" },
    /**商家*/ { path: "/store/orderHx" },
  ];
  private hx_click() {
    // return console.log(this.$route.query.type);

    this.$router.push({
      path: this.arr[this.$route.query.type].path,
      query: { code: this.orderId },
    });
  }
  scan_click() {
    WxUtil.get_wx().then((wx) => {
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res: any) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        },
      });
    });
  }
}
